import React, {lazy, Suspense, useState} from "react";
import {
    Button,
    Select,
    Option, Dialog, DialogHeader, DialogBody, DialogFooter,
} from "@material-tailwind/react";
import {
    ChevronDownIcon,
    ChevronRightIcon,
} from "@heroicons/react/24/solid";
import InputMask from "react-input-mask";
import axios from "axios";

const Movements = ({reasonsTypes}) => {
    const [step, setStep] = useState(1);
    const [searchType, setSearchType] = useState("search_by_name");
    const [parcelCode, setParcelCode] = useState("");
    const [lot, setLot] = useState(null);
    const [lots, setLots] = useState([]);
    const [selectedContributor, setSelectedContributor] = useState(null);
    const [contributors, setContributors] = useState(null);
    const [name, setName] = useState("");
    const [pLastName, setPLastName] = useState("");
    const [mLastName, setMLastName] = useState("");
    const [movementId, setMovementId] = useState("");
    const [selectedMovement, setSelectedMovement] = useState(null);
    const [error, setError] = useState(null);

    const [openResetDialog, setOpenResetDialog] = useState(false);

    const DomainTransfer = lazy(() => import("./movements/domain_transfer"));
    const Revaluation = lazy(() => import("./movements/revaluation"));
    const ValueReduction = lazy(() => import("./movements/value_reduction"));
    const AddressCorrection = lazy(() => import("./movements/address_correction"));
    const NameCorrection = lazy(() => import("./movements/name_correction"));
    const LandCorrection = lazy(() => import("./movements/land_correction"));
    const Fusion = lazy(() => import("./movements/fusion"));
    const LotDetails = lazy(() => import("./movements/lot_details"));
    const LotSubtraction = lazy(() => import("./movements/lot_subtraction"));
    const LotSegregation = lazy(() => import("./movements/lot_segregation"));
    const EffectiveDateCorrection = lazy(() => import("./movements/effective_date_correction"));
    const DeleteLot = lazy(() => import("./movements/delete_lot"));
    const RegistryReview = lazy(() => import("./movements/registry_review"));
    const ValuesAdjustment = lazy(() => import("./movements/values_adjustment"));
    const CodeCorrection = lazy(() => import("./movements/code_correction"));
    const ConstructionAddition = lazy(() => import("./movements/construction_addition"));
    const Franchise = lazy(() => import("./movements/franchise"));
    const Affectation = lazy(() => import("./movements/affectation"));
    const SalePromise = lazy(() => import("./movements/sale_promise"));
    const DataEntryCorrection = lazy(() => import("./movements/data_entry_correction"));

    const movementComponents = {
        1: DomainTransfer,
        2: DomainTransfer,
        3: DomainTransfer,
        4: DomainTransfer,
        5: DomainTransfer,
        6: DomainTransfer,
        7: DomainTransfer,
        8: DomainTransfer,
        9: DomainTransfer,
        10: DomainTransfer,
        11: ConstructionAddition,
        12: Revaluation,
        13: Revaluation,
        14: ValueReduction,
        15: Franchise,
        16: EffectiveDateCorrection,
        17: DeleteLot,
        18: AddressCorrection,
        19: NameCorrection,
        20: LandCorrection,
        21: Affectation,
        22: Fusion,
        23: SalePromise,
        24: Franchise,
        25: LotSubtraction,
        26: LotSegregation,
        27: LotDetails,
        28: RegistryReview,
        29: ValuesAdjustment,
        30: DataEntryCorrection,
        33: CodeCorrection,
    }

    const propsMap = {
        1: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        2: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        3: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        4: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        5: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        6: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        7: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        8: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        9: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        10: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        11: {lot: lot, movement: selectedMovement},
        12: {lot: lot, movement: selectedMovement},
        13: {lot: lot, movement: selectedMovement},
        14: {lot: lot, movement: selectedMovement},
        15: {lot: lot, movement: selectedMovement},
        16: {lot: lot, movement: selectedMovement},
        17: {lot: lot, movement: selectedMovement},
        18: {lot: lot, movement: selectedMovement},
        19: {lot: lot, movement: selectedMovement},
        20: {lot: lot, movement: selectedMovement},
        21: {lot: lot, movement: selectedMovement},
        22: {lot: lot, movement: selectedMovement},
        23: {lot: lot, movement: selectedMovement},
        24: {lot: lot, movement: selectedMovement},
        25: {lot: lot, movement: selectedMovement},
        26: {lot: lot, movement: selectedMovement},
        27: {parcelCode: parcelCode, lot: lot, movement: selectedMovement},
        28: {lot: lot, movement: selectedMovement},
        29: {lot: lot, movement: selectedMovement},
        30: {lot: lot, movement: selectedMovement},
        33: {lot: lot, movement: selectedMovement},
    }
    const SelectedComponent = movementComponents[movementId];

    const handleReset = () => {
        setStep(1);
        setSearchType("search_by_name");
        setParcelCode("");
        setLot(null);
        setLots([]);
        setSelectedContributor(null);
        setContributors(null);
        setName("");
        setPLastName("");
        setMLastName("");
        setMovementId("");
        setSelectedMovement(null);
        setError(null);
        setOpenResetDialog(false)
    };

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    const handleBuscar = async () => {
        setError(null);
        setLot(null);
        setLots([]);
        setSelectedContributor(null);

        setSelectedMovement(reasonsTypes.find((item => item.id === parseInt(movementId))));

        if (movementId.trim() === "") {
            alert("Seleccione un movimiento a realizar");
        } else {

            if (searchType === "search_by_cve") {
                if (parcelCode.trim() === "") return setError("Ingrese una clave válida");

                await handleSelectPredio(parcelCode);
            } else if (searchType === "search_by_name") {
                if (name.trim() === "" && pLastName.trim() === "" && mLastName.trim() === "") return alert("Ingrese un nombre válido");

                try {
                    const response = await fetch(`/lots/search_by_name?name=${name}&parental_last_name=${pLastName}&maternal_last_name=${mLastName}&reason_type=${movementId}`);

                    if (!response.ok) {
                        setError("No se encontraron contribuyentes.");
                        setStep(1);
                        return;
                    }

                    const data = await response.json();
                    setContributors(data);
                } catch (err) {
                    console.error("Error al buscar el predio:", err);
                }
            }
        }
    };

    const handleGetLotsByContributor = async (contributorId) => {
        try {
            const response = await fetch(`/lots/search_by_contributor?id=${contributorId}`);
            const data = await response.json();
            setLots(data);
            setSelectedContributor(contributorId);
        } catch (err) {
            console.error("Error fetching lots:", err);
        }
    };

    const handleSelectPredio = async (parcel_code) => {
        setParcelCode(parcel_code);

        try {
            const [lotsResponse] = await Promise.all([
                fetch(`/lots/${parcel_code}/search_by_code.json`),
            ]);

            if (!lotsResponse.ok) {
                setError("No se encontraron datos para este código.");
                setStep(1);
                return;
            } else {

            }
            const lotsData = await lotsResponse.json();
            setLot(lotsData);

        } catch (err) {
            console.error("Error al buscar el predio:", err);
        }

        setStep(2);
    };

    const handleValidateParcelCode = async () => {
        setSelectedMovement(reasonsTypes.find((item => item.id === parseInt(movementId))));

        await axios.post(`lots/validate_parcel_code.json`, {
            parcel_code: parcelCode,
        }, {
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": getCSRFToken(),
            }
        })
            .then(response => {
                const data = response.data;

                if (data.available) {
                    setLot({
                        parcel_code: parcelCode,
                        location_type_id: data.location_type_id,
                        sector_id: data.sector_id,
                        sector_name: data.sector_name,
                        block_id: data.block_id,
                        block_name: data.block_name,
                        batch: data.batch,
                    });
                    setError(null);
                    setStep(2);
                } else {
                    setError(`La clave catastral ya se encuentra en uso, clave sugerida: ${data.suggested}`);
                }
            })
            .catch(error => {
                setError('Error al verificar la clave catastral.');
                console.error(error);
            });
    }

    return (
        <>
            <div className="min-w-screen min-h-screen pb-5">
                <div className="w-full bg-white border-gray-200 px-5 py-10 text-gray-800">
                    {step === 1 && (
                        <>
                            <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                PREDIOS
                            </h6>
                            <div className="mb-6">
                                <div className="mt-4 bg-white p-6 rounded shadow-md">
                                    <span
                                        className="text-lg font-bold whitespace-nowrap pr-4">Movimiento a realizar:</span>
                                    <Select
                                        value={movementId}
                                        onChange={(e) => (setMovementId(e))}
                                        className="w-full"
                                        label='Seleccione movimiento'
                                    >
                                        {reasonsTypes.map((reason) => (
                                            <Option key={reason.id.toString()} value={reason.id.toString()}>
                                                {reason.id.toString()} - {reason.description}
                                            </Option>
                                        ))}
                                    </Select>

                                </div>
                            </div>
                            {movementId === '25' && (
                                <div className="mt-4 bg-white p-6 rounded shadow-md">
                                    <section id="find_by_cve">
                                        <div
                                            className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                            <div>
                                                <h1 className="font-bold text-lg">ALTA DE PREDIO</h1>
                                                <p className="text-sm text-gray-500">
                                                    Ingresa la nueva clave catastral.
                                                </p>
                                                {error && <p style={{color: "red"}}>{error}</p>}
                                            </div>
                                            <div className="flex gap-2">
                                                <div className="lg:w-96">
                                                    <InputMask
                                                        mask="519999-999-999"
                                                        value={parcelCode}
                                                        onChange={(e) => setParcelCode(e.target.value)}
                                                    >
                                                        {(inputProps) => (
                                                            <input
                                                                {...inputProps}
                                                                type="text"
                                                                placeholder="51XXXX-XXX-XXX"
                                                                className="p-2 w-full border border-gray-300 rounded"
                                                            />
                                                        )}
                                                    </InputMask>
                                                </div>
                                                <Button onClick={handleValidateParcelCode}
                                                >
                                                    Buscar
                                                </Button>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            )}
                            {(movementId && movementId !== '25') && (
                                <div className="mb-6">
                                    <div className="flex gap-4 items-center bg-gray-100 p-4 rounded">
                                        <span className="text-lg font-bold whitespace-nowrap pr-4">Búsqueda por:</span>
                                        <Select
                                            value={searchType}
                                            onChange={(e) => setSearchType(e)}
                                            className="w-full"
                                        >
                                            <Option value="search_by_cve">Clave catastral</Option>
                                            <Option value="search_by_name">Nombre y Apellidos</Option>
                                        </Select>
                                    </div>
                                    <div className="mt-4 bg-white p-6 rounded shadow-md">
                                        {searchType === "search_by_cve" && (
                                            <section id="find_by_cve">
                                                <div
                                                    className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                    <div>
                                                        <h1 className="font-bold text-lg">BUSQUEDA POR PREDIO</h1>
                                                        <p className="text-sm text-gray-500">
                                                            Ingresa la clave catastral para buscar.
                                                        </p>
                                                        {error && <p style={{color: "red"}}>{error}</p>}
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <div className="lg:w-96">

                                                            <InputMask
                                                                mask="519999-999-999"
                                                                value={parcelCode}
                                                                onChange={(e) => setParcelCode(e.target.value)}
                                                            >
                                                                {(inputProps) => (
                                                                    <input
                                                                        {...inputProps}
                                                                        type="text"
                                                                        placeholder="51XXXX-XXX-XXX"
                                                                        className="p-2 w-full border border-gray-300 rounded"
                                                                    />
                                                                )}
                                                            </InputMask>
                                                        </div>
                                                        <Button onClick={handleBuscar}>Buscar</Button>
                                                    </div>
                                                </div>
                                            </section>
                                        )}
                                        {searchType === "search_by_name" && (
                                            <>
                                                <section id="find_by_name">
                                                    <div
                                                        className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                        <div>
                                                            <h1 className="font-bold text-lg">BUSQUEDA POR NOMBRE</h1>
                                                            <p className="text-sm text-gray-500">
                                                                Ingresa los datos del predio para buscar.
                                                            </p>
                                                            {error && <p style={{color: "red"}}>{error}</p>}
                                                        </div>
                                                        <div className="flex flex-wrap gap-2 items-center">
                                                            <input
                                                                type="text"
                                                                placeholder="Nombre"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value.toUpperCase())}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Paterno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={pLastName}
                                                                onChange={(e) => setPLastName(e.target.value.toUpperCase())}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Materno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={mLastName}
                                                                onChange={(e) => setMLastName(e.target.value.toUpperCase())}
                                                            />
                                                            <Button onClick={handleBuscar}>Buscar</Button>
                                                        </div>
                                                    </div>
                                                </section>
                                            </>
                                        )}
                                    </div>
                                    {searchType === "search_by_name" && contributors && (
                                        <div className="mt-8">
                                            {contributors.length > 0 ? (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                                        Resultados de búsqueda
                                                    </h6>

                                                    <ul className="border p-4 rounded-md bg-white shadow">
                                                        {contributors.map((contributor, index) => (
                                                            <li key={contributor.id}
                                                                className={`${index === contributors.length - 1 ? "" : "border-b"}`}>
                                                                <div
                                                                    className="flex justify-between items-center py-3 px-4 rounded-md cursor-pointer hover:bg-blue-gray-50 transition duration-200"
                                                                    onClick={() => handleGetLotsByContributor(contributor.id)}
                                                                >
                                                                    <span className="text-gray-700 font-medium">
                                                                        <strong>
                                                                          {contributor.name} {contributor.parental_last_name} {contributor.maternal_last_name}
                                                                        </strong>
                                                                    </span>
                                                                    {selectedContributor === contributor.id ? (
                                                                        <ChevronDownIcon
                                                                            className="h-5 w-5 text-gray-700"/>
                                                                    ) : (
                                                                        <ChevronRightIcon
                                                                            className="h-5 w-5 text-gray-500"/>
                                                                    )}
                                                                </div>
                                                                {selectedContributor === contributor.id && (
                                                                    <ul className="p-4 mt-2 bg-blue-gray-500/20 rounded-md">
                                                                        {lots.length > 0 ? (
                                                                            lots.map((lot, index) => (
                                                                                <li
                                                                                    key={`${lot.parcel_code}-${index}`}
                                                                                    className={`flex justify-between items-center py-2 px-3 rounded-md cursor-pointer hover:bg-gray-100 transition duration-200 hover:bg-brown-500/10 ${index === lots.length - 1 ? "" : "border-b border-blue-gray-50"}`}
                                                                                    onClick={() => handleSelectPredio(lot.parcel_code)}
                                                                                >
                                                                                  <span className="text-gray-600">
                                                                                    <strong>{lot.parcel_code}</strong>: {`${lot.road_name}${lot.ext_num ? ' #' + lot.ext_num : ''}, ${lot.neighborhood_name}`}
                                                                                  </span>
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <li className="text-gray-500 italic">No se
                                                                                encontraron <strong>predios.</strong>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 my-4 text-center">
                                                        No se encontraron coincidencias.
                                                    </h6>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}

                    {step === 2 && (
                        <>
                            <h6 className="font-semibold uppercase text-gray-600 mb-2">
                                Movimiento
                            </h6>
                            <div className="bg-white p-5 border rounded-md mb-4">
                                <div className="flex justify-between items-center">
                                    <div className='flex flex-col gap-2'>
                                        <div>
                                            <h6 className="font-semibold">Movimiento a realizar:</h6>
                                            <p>{selectedMovement.id} - {selectedMovement.description}</p>
                                        </div>
                                        <div>
                                            <h6 className="font-semibold">Clave Buscada:</h6>
                                            <p>{parcelCode}</p>
                                        </div>
                                    </div>
                                    <Button
                                        size="sm"
                                        className="mt-2 bg-red-700"
                                        onClick={() => setOpenResetDialog(true)}
                                        style={{marginLeft: 'auto'}}
                                    >
                                        Restablecer
                                    </Button>
                                </div>
                            </div>
                            <Dialog open={openResetDialog} handler={setOpenResetDialog}>
                                <DialogHeader>Confirmación</DialogHeader>
                                <DialogBody>¿Estás seguro de restablecer?</DialogBody>
                                <DialogFooter>
                                    <Button
                                        variant="text"
                                        onClick={() => setOpenResetDialog(false)}
                                        className="mr-2"
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        className="bg-red-500 text-white"
                                        onClick={handleReset}
                                    >
                                        Confirmar
                                    </Button>
                                </DialogFooter>
                            </Dialog>

                            <Suspense fallback={<div className="text-gray-500">Cargando vista...</div>}>
                                {SelectedComponent ? <SelectedComponent {...(propsMap[movementId] || {})} /> :
                                    <div>Selecciona una opción</div>}
                            </Suspense>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default Movements;
